<template>
  <span class="d-inline align-items-center d-flex flex-wrap my-2">
    <span
      v-for="aggregation in aggregations"
      :key="aggregation.id"
      :title="aggregation.title"
      class="aggregation-card d-inline-flex align-items-center mr-4"
    >
      <slot v-bind:aggregation="aggregation">
        <component
          v-if="aggregation.iconComponent"
          :is="aggregation.iconComponent"
          :size="18"
          :style="{ color: aggregation.iconColor }"
          class="mr-2"
        />
        <i v-else class="mr-2" :class="aggregation.iconClass"></i>
        <span class="font-weight-bold text-dark-75">{{ aggregation.data }}</span>
      </slot>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    aggregations: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.aggregation-card {
  height: var(--control-h-sm);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0 10px;
  background-color: var(--surface);
}
</style>
